var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.insideFolder)?_c('div',{staticClass:"ms-2"},[_c('button',{staticClass:"btn-close btn-sm",attrs:{"type":"button"},on:{"click":_vm.removeArticle}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }